import { createAction } from 'redux-actions';
import Types from './types';

export const setFilterValues = createAction(Types.SET_FILTER_VALUES);

export const setClientsFilterValues = createAction(
  Types.SET_CLIENTS_FILTER_VALUES
);
